namespace Matrix.Rebalancer {
    export class SummaryViewAccountColumns {
        static columnsKey = 'Rebalancer.SummaryViewAccount';
    }
}
